import { EMPTY_STR } from '@lacele/const'

const asString = (obj) => (typeof (obj) === 'number' ? String(obj) : obj)

// Joins string items by a delimiter.
// Skips empty items.
// Avoids delimiter duplication between items.
export default (delimiter, initial, ...rest) => rest.reduce(
    (previous, current) => {
        const delimiterLocal = delimiter || EMPTY_STR
        const currentLocal = asString(current)
        if (!currentLocal) {
            return previous
        }
        if (currentLocal.startsWith(delimiterLocal)) {
            if (previous.endsWith(delimiterLocal)) {
                return previous + currentLocal.substr(delimiterLocal.length)
            }
            return previous + currentLocal
        }
        if (!previous) {
            return currentLocal
        }
        if (previous.endsWith(delimiterLocal)) {
            return previous + currentLocal
        }
        return previous + delimiterLocal + currentLocal
    }, asString(initial) || EMPTY_STR
)
